export enum ChangeSummaryChangeType {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  DELETED = 'DELETED',
  UNCHANGED = 'UNCHANGED',
}
